export default __webpack_public_path__ + "static/media/Chocolate Milkshake - proportioned_170.f4a7ea47.jpg";